import sendRequestDesignDataPostMessageOperation from 'src/store/app/operation/sendRequestDesignDataPostMessageOperation';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { AppDispatch } from 'src/store/index';

/**
 * OP-39782: same pre-commit round-trip as the single add — asks the editor for
 * the latest design data, then routes to the multi-size batch commit via the
 * host.addToBasketMultiSize callback (handled in PostMessageReceiver).
 */
const sendRequestDesignDataPostMessageToMultiSizeAddToBasketOperation = () => (dispatch: AppDispatch) => {
  const callbackMessage = {
    type: MESSAGE_TYPE['host.addToBasketMultiSize'],
  };
  dispatch(sendRequestDesignDataPostMessageOperation(callbackMessage, true));
};

export default sendRequestDesignDataPostMessageToMultiSizeAddToBasketOperation;
